import { ADDNEWPRODUCT, DECREMENT, INCREMENT } from "./actionTypes";

export const addNewProductToTheCart = (value, id) => {
  return {
    type: ADDNEWPRODUCT,
    payload: value,
    id: id,
  };
};
export const increaseProductToTheCart = (value, id) => {
  return {
    type: INCREMENT,
    payload: value,
    id: id,
  };
};
export const decreaseProductToTheCart = (value, id) => {
  return {
    type: DECREMENT,
    payload: value,
    id: id,
  };
};
